/**
 * This use data-slideshow so that it is possible to manually create other
 * types of slideshows if needed.
 *
 * Example:
 * <ul class="bxslider" data-slideshow> ... <li><img ...></li> ... </ul>
 * Some configuration can be passed with data-* attributes on the .bxslider
 * data-mode: 'horizontal', 'vertical', 'fade' (default fade)
 * data-video: 'true', 'false' (default false)
 * data-touchEnabled: 'true', 'false' (default false)
 * data-pager: 'true', 'false' (default false)
 * data-infiniteloop: 'true', 'false' (default true)
 * data-controls: 'true', 'false' (default true)
 * data-nextText: The text displayed on the next button (default 'Next')
 * data-prevText: The text displayed on the next button (default 'Prev')
 * data-auto: 'true', 'false' (default false)
 * data-pause: milliseconds before auto next slide (default 4000)
 *
 * example:
 * <ul class="bxslider" data-slideshow data-mode="vertical" data-pager="true">
*/

import $ from 'jquery';

export default class Slideshow {
  constructor() {
    this.$items = $('[data-slideshow]');
    if (this.$items.length) {
      this.init();
    }
  }

  init() {
    var self = this;
    require(['../../vendors/bower_components/bxslider-4/jquery.bxslider.js'], function onBxSliderLoaded() {
      self.$items.each(function sliderEach() {
        self.setElement(this);
      });
    });
  }

  setElement(el) {
    var $this = $(el);
    var mode = $this.data('mode') || 'fade';
    var video = $this.data('video');
    var touchEnabled = $this.data('touchEnabled') || false;
    var pager = $this.data('pager') || false;
    var infiniteLoop = ($this.data('infiniteloop') !== undefined) ? $this.data('infiniteloop') : true;
    var controls = ($this.data('controls') !== undefined) ? $this.data('controls') : true;
    var nextText = $this.data('nextText') || 'Next';
    var prevText = $this.data('prevText') || 'Prev';
    var auto = $this.data('auto') || false;
    var pause = $this.data('pause') || 4000;

    $this.bxSlider({
      mode: mode,
      video: video,
      touchEnabled: touchEnabled,
      pager: pager,
      controls: controls,
      nextText: nextText,
      prevText: prevText,
      auto: auto,
      pause: pause,
      infiniteLoop: infiniteLoop
    });
  }
}



/** WEBPACK FOOTER **
 ** ./plugins/Slideshow/Slideshow.js
 **/